import { randomBytes } from 'crypto';

export const idGenerator = {
  /**
   * 生成 TraceId (128-bit / 32-char hex)
   * 符合 W3C Trace Context 标准
   * 示例: "5b8efff798038103d269b633813fc60c"
   */
  generateTraceId(): string {
    // 16 字节 = 128 位，转为 hex 就是 32 个字符
    return randomBytes(16).toString('hex');
  },

  /**
   * 生成 SpanId (64-bit / 16-char hex)
   * 示例: "eee19b7ec3c1b174"
   */
  generateSpanId(): string {
    // 8 字节 = 64 位，转为 hex 就是 16 个字符
    return randomBytes(8).toString('hex');
  }
};